<template>
  <div class="container">
 <br />
  <router-link to="/broadcaster/recordings" >{{ $t('back-to-recordings') }}</router-link>
   <br />
   <br />
    <h2>{{ recording.title}}</h2>
    <hr />
    <div class="mobile-grid">
    <router-link class="btn btn-dark"  v-bind:to="'/'+channel.id+'/recording/'+recording.session">{{ $t('view-recording') }}</router-link > <a role="button"  v-bind:href="'https://app.seasoncast.com/v2/recording/download?channel_id='+channel.id+'&session='+recording.session" class="btn btn-dark">{{ $t('download-recording') }}</a> <router-link class="btn btn-dark" v-bind:to="'/broadcaster/event/'+recording.event">{{ $t('go-to-event') }}</router-link >  <button @click="deleteRecording" class="btn btn-danger">{{ $t('delete-recording') }}</button>
      </div>
      <br /><br />
       <recording :recording="recording" :channel_id="channel.id"  >
    </recording> 
   <hr />
    <div class="seasoncast-card" >
      <span>{{ $t('views-recording-views', [recording.viewsLive ? recording.viewsLive + recording.views : recording.views]) }}</span><br />
      <span v-if="recording.viewsLive != undefined">Live Views: {{ recording.viewsLive }}<br /></span>
      <span>{{ $t('duration-recording-duration-or-timetostring', [recording.duration | timeToString]) }}</span>
   </div> 
   <br />
   <PlayerLive v-if="channel && recording.session"  :channel="channel" :isLive="false" :recording_id="recording.session" ></PlayerLive>

   <br />
   <!-- seasoncast-card div -->
  <hr />
    <div class="seasoncast-card" >
  <h4>{{ $t('display-this-recording-on-your-website') }} <span style="font-size:0.5em;vertical-align:middle;" class="badge badge-dark">{{ $t('premium-only') }}</span></h4>
    <p>{{ $t('insert-this-html-into-your-website-to-display-this-event') }}</p>
    <pre class=" language-html"><code class=" language-html"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>SeasonCastEvent<span class="token punctuation">"</span></span> <span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>position:relative;width:100%;height:0;padding-bottom:56.25%;overflow:hidden<span class="token punctuation">"</span></span><span class="token punctuation">&gt;</span></span>
  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>iframe</span> <span class="token attr-name">src</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>https://{{ channel.id}}.mylivegame.com/embed/{{recording.session}}<span class="token punctuation">"</span></span> <span class="token attr-name">width</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>1280<span class="token punctuation">"</span></span> <span class="token attr-name">height</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>720<span class="token punctuation">"</span></span> <span class="token attr-name">allowfullscreen</span> <span class="token attr-name">frameborder</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>position:absolute;width:100%;height:100%;left:0;top:0;<span class="token punctuation">"</span></span><span class="token punctuation">&gt;</span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>iframe</span><span class="token punctuation">&gt;</span></span>
<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">&gt;</span></span>
</code></pre>
   <br />
   </div>
    <br />
   </div>
   
</template>

<script>
import axios from "axios"
import Swal from "sweetalert2"
import recording from '../Recording.vue' 
import PlayerLive from '../player/PlayerLive.vue'

let API = "https://app.seasoncast.com/"

export default { 
  name: 'Home',
  props: ['channel'],
  components: {
      recording,
      PlayerLive
    
  },
  filters: {
    //take in seconds and return a string of hours, minutes, seconds
    timeToString: function(time) {
      let hours = Math.floor(time / 3600);
      let minutes = Math.floor((time % 3600) / 60);
      let seconds = Math.floor(time % 60);
      let output = "";
      if (hours > 0) {
        output += hours + " hours, ";
      }
      if (minutes > 0) {
        output += minutes + " minutes, ";
      }

      output += seconds + " seconds";
      return output;
    }
  },
  data: function () {
    return {
        recording
    }
  },
  created: async function () {

await this.getChannelEvent()
  },
  methods: {
    // deleteRecording : call endpoint v2/broadcaster/recording/delete with session_id
    deleteRecording: async function () {
      const didConfirm = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this recording!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      })
      if (didConfirm.isConfirmed) {
        await axios.post(API + "v2/broadcaster/recording/delete", {
          session_id: this.recording.session,
           ...this.$store.state.broadcasterAuth,
        })
        this.$router.push('/broadcaster/recordings')
      }
    },
    getChannelEvent: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel/recording", {
    channel_id: this.channel.id,
    recording_id: this.$route.params.option
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
  this.recording = responseData.recording
  


    },
  }
}
</script>